import _isArray from 'lodash/isArray';

function exec(next, action, client, res) {
    const { promise, types, ...rest } = action;

    if (!promise) {
        return next(action);
    }

    const [REQUEST, SUCCESS, FAILURE] = types;
    next({ ...rest, type: REQUEST });

    return promise(client, res)
        .then(
            (result) => next({ ...rest, result, type: SUCCESS }),
            (error) => next({ ...rest, error, type: FAILURE })
        )
        .catch((error) => {
            // Defer throwing so execution can continue; throw so TrackJS can log error
            setTimeout(() => {
                throw error;
            });
            next({ ...rest, error, type: FAILURE });
        });
}

/**
* Support for multiple consecutive promises.
* API (in your action creator):
*
* return [{
        types: ['sap', 'dap', 'fap'],
        promise: (client, result) => sap(client, result),
        meta: {hello: 'world'}
    }, {
        types: ['sap2', 'dap2', 'fap2'],
        promise: (client, result) => sap2(client, result),
        meta: {hello: 'world2'}
    }];
*/
function recursiveExec(actions, index, next, client, result) {
    if (index >= actions.length) {
        return Promise.resolve();
    }

    return exec(next, actions[index], client, result).then((_result) =>
        recursiveExec(actions, index + 1, next, client, _result)
    );
}

export default function clientMiddleware(client) {
    return ({ dispatch, getState }) =>
        (next) =>
        (action) => {
            if (typeof action === 'function') {
                return action(dispatch, getState);
            }

            if (_isArray(action)) {
                return recursiveExec(action, 0, next, client);
            } else {
                return exec(next, action, client);
            }
        };
}
